
import marked from "marked";
import Vue from "vue";
import axios from "axios";
import ProgressiveImage from "@/components/ProgressiveImage.vue";
import { heroCarouselMixin } from "@/utils/heroCarousel";
import { publicAssetUrls } from "@/utils/publicAsset";

let rendererMD = new marked.Renderer();
marked.setOptions({
  renderer: rendererMD,
  gfm: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
});
rendererMD.heading = function (text, level) {
  return `<h${level} style="margin-bottom:20px;margin-top:20px">${text}</h${level}>`;
};
rendererMD.link = function (href, title, text) {
  return `<a style="color:var(--color-primary);text-decoration:none;" href=${href}>${text}</a>`;
};

const LAB_REL = "img/groups/lab.jpg";

export default Vue.extend({
  components: { ProgressiveImage },
  mixins: [heroCarouselMixin],
  data: () => ({
    text: "",
    papers: [] as any,
    labPhotoFull: "" as string,
    labPhotoThumb: "" as string,
  }),
  computed: {
    /** Split at ## Highlights (same group photo as Chinese homepage / HomeAbout). */
    introSegments(): { intro: string; highlightsBlock: string; tail: string } | null {
      const t = this.text;
      if (!t) return null;
      const re = /\n(?=#{1,6}\s+Highlights\b)/i;
      const i = t.search(re);
      if (i === -1) return null;
      const intro = t.slice(0, i);
      const hlAll = t.slice(i + 1);
      const nextIdx = hlAll.search(/\n(?=#{1,6}\s+)/);
      if (nextIdx === -1) {
        return { intro, highlightsBlock: hlAll, tail: "" };
      }
      return {
        intro,
        highlightsBlock: hlAll.slice(0, nextIdx),
        tail: hlAll.slice(nextIdx + 1),
      };
    },
    markedIntroHtml(): string {
      const s = this.introSegments;
      return s ? marked(s.intro) : marked(this.text);
    },
    markedHighlightsHtml(): string {
      const s = this.introSegments;
      return s ? marked(s.highlightsBlock) : "";
    },
    markedTailHtml(): string {
      const s = this.introSegments;
      return s && s.tail ? marked(s.tail) : "";
    },
    markdown(): string {
      return marked(this.text);
    },
  },
  created() {
    const urls = publicAssetUrls(LAB_REL);
    this.labPhotoFull = urls.full;
    this.labPhotoThumb = urls.thumb;
  },
  mounted() {
    axios
      .post(Vue.prototype.apiUrl("get-item"), {
        collection: "intro",
        need: { index: -2 },
      })
      .then((response) => {
        const items = (response.data as any) || [];
        if (!items.length) return;
        const tmp = items[0].content;
        this.text = Vue.prototype.replaceLocalhostInContent(tmp);
      });

    this.getPaperList();
  },
  methods: {
    getPaperList() {
      axios.get(Vue.prototype.apiUrl("publications")).then((response) => {
        const all = (response.data || []) as any[];
        this.papers = all.slice(0, 20);
      });
    },
  },
});
